import {BaseEntity} from "./base-entity";
import {DataNode} from "antd/es/tree";
import * as React from "react";

export class TreeEntity extends BaseEntity{
    title?: React.ReactNode | ((data: DataNode) => React.ReactNode);
    label!:string
    key!:string
    selectable!:boolean
    highLight!:string
    children!: TreeEntity[];
    type!:number;
}